import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import ToastrService from "../../services/toastService";
import Loader from "../loader/loader"
import Swal from "sweetalert2";
import { Logout, shouldLogout } from '../Common/Common'
import { useNavigate } from "react-router-dom";
import { useAddTsFlowMutation, useUpdateTsFlowMutation } from "./Api";

const AddFlow = ({
    mode = "add",
    onClose,
    onSave,
    data = null,
    selectIntent,
    addlatestValue
}) => {

    const [addFlowApi, { isLoading }] = useAddTsFlowMutation()
    const [updateFlowApi, { isLoading: updateIsLoading }] = useUpdateTsFlowMutation()

    const navigate = useNavigate()

    const validationSchema = Yup.object().shape({
        flow_name: Yup.string()
            .required('Flow Name is required')
            .matches(/^[A-Za-z\s]+$/, 'Enter valid flow name')
            .trim(),
        description: Yup.string()
            .required('Description is required')
            .trim(),
    });

    const { register, handleSubmit, reset, watch, setValue, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'all'
    });

    useEffect(() => {
        if (data) {
            reset({
                flow_name: data.flow_name,
                description: data.description,
            });
        }
    }, [])


    const resetButton = () => {
        reset({
            flow_name: "",
            description: "",
        });
    };

    const onSubmit = async (payload) => {
        try {
            if (mode == 'add') {

                const values = {
                    intent_id: selectIntent,
                    flow_name: payload.flow_name,
                    description: payload.description,
                }

                const response = await addFlowApi(values)

                if (response?.data?.success) {
                    ToastrService.success(response?.data?.message);
                    addlatestValue('flow', Number(response?.data?.data?.id))
                    reset()
                    onSave()
                } else {
                    if (shouldLogout(response.error)) {
                        Logout(navigate);
                        return
                    }
                    ToastrService.error(response.error.data.message);
                }

            } else {

                const values = {
                    intent_id: selectIntent,
                    flow_name: payload.flow_name,
                    description: payload.description,
                    id: data.id
                }

                const response = await updateFlowApi(values)

                if (response?.data?.success) {
                    ToastrService.success(response?.data?.message);
                    reset()
                    onSave()
                } else {
                    if (shouldLogout(response.error)) {
                        Logout(navigate);
                        return
                    }
                    ToastrService.error(response.error.data.message);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }

    return (
        <div>
            {isLoading || updateIsLoading ? <Loader /> :
                <>
                    <div className="offcanvas offcanvas-end show" style={{ visibility: "visible" }} tabIndex="-1">

                        <div className="offcanvas-header px-4 py-3">

                            <div>
                                <h3 className="mb-1 drawer-header">
                                    {mode === "add" ? "Create New Flow" : "Manage Flow"}
                                </h3>
                                <small className="text-muted">{mode === "add" ? "Fill in the details below to create a Troubleshooting Flow." : "Update the details below to Manage Troubleshooting Flow"}</small>
                            </div>

                            <button
                                type="button"
                                className="btn-close text-reset"
                                onClick={onClose}
                                aria-label="Close"
                            ></button>

                        </div>


                        <div className="offcanvas-body px-4 py-3">

                            <form autoComplete="off" noValidate onSubmit={handleSubmit(onSubmit)}>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Flow Name <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="flow_name"
                                        name='flow_name'
                                        placeholder='Enter the Flow name'
                                        {...register('flow_name')}
                                        className="form-control"

                                    />
                                    {errors.flow_name && (
                                        <p className="mt-2" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.flow_name.message}
                                        </p>
                                    )}
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">
                                        Description <span className="text-danger">*</span>
                                    </label>
                                    <textarea
                                        id="description"
                                        placeholder="Brief description of the Flow..."
                                        name='description'
                                        {...register('description')}
                                        className="description-input"
                                    />
                                    {errors.description && (
                                        <p className="mt-1" style={{ color: "#d93025", fontFamily: "revert", marginLeft: '1%' }}>
                                            {errors.description.message}
                                        </p>
                                    )}
                                </div>

                                <div className="d-flex gap-2 mt-4">
                                    <button type="submit" className="btn btn-primary">
                                        {mode === "add" ? "Create flow" : "Update flow"}
                                    </button>

                                    {mode === "add" && (
                                        <button type="button" className="btn btn-secondary" onClick={resetButton}>
                                            Reset
                                        </button>
                                    )}
                                </div>

                            </form>

                        </div>
                    </div>

                    {/* Backdrop */}
                    <div className="offcanvas-backdrop fade show" onClick={onClose}></div>

                </>
            }
        </div>

    );
};

export default AddFlow;